// Configuration for firebase authentication

const firebaseConfig = {
  apiKey: 'AIzaSyDR11brqexHHkZ1HaXrc1nc4uq9UjBr5KI',
  authDomain: 'madagaar-fba66.firebaseapp.com',
  databaseURL: 'https://madagaar-fba66.firebaseio.com',
  projectId: 'madagaar-fba66',
  storageBucket: 'madagaar-fba66.appspot.com',
  messagingSenderId: '551648998204',
  appId: '1:551648998204:web:07265a1b617ff2615f6439',
  measurementId: 'G-P84Q0ZHYK1',
};

export default firebaseConfig;
